export const Footer = () => {
  return (
    <footer className="mt-auto pt-4 text-center">
      <div className="flex items-center justify-center gap-2 text-sm text-slate-500">
        <span>Connecta 2026</span>
      </div>
    </footer>
  );
};
